module.exports = __webpack_public_path__ + "img/horizontal_6_6_8017.5937a3d0.png";